import { searchReport } from '@/reports/searchReport';
import type { PhoneSearchRequestBody } from '@/reports/searchReport';

export interface PhoneFraudSearchParams {
  phone: string;
  phone_number?: string;
  'h-captcha-response'?: string;
}

export async function phoneFraudSearch(phoneProps: PhoneFraudSearchParams) {
  const phone = phoneProps.phone || phoneProps.phone_number || '';
  const body: PhoneSearchRequestBody = {
    report_type: 'phone_fraud_report',
    meta: {
      phone_number: phone[0] === '1' ? phone.slice(1, phone.length) : phone,
      report_flags: [],
    },
    'h-captcha-response': phoneProps['h-captcha-response'] || '',
  };

  return searchReport(body);
}
